module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "calendarComponent"
    }
  }, [_c('br'), _vm._v(" "), (_vm.errorMsg) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_c('p', [_vm._v(_vm._s(_vm.errorMsg))])]) : _vm._e(), _vm._v(" "), (_vm.alertMsg) ? _c('div', {
    staticClass: "alert alert-info"
  }, [_c('p', [_vm._v(" " + _vm._s(_vm.alertMsg))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    attrs: {
      "id": "calendar"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "remove-margins col-sm-12 col-xs-12"
  }, [_c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn-block btn btn-info",
    on: {
      "click": function($event) {
        _vm.addNewEventButton()
      }
    }
  }, [_vm._v("Add a new event")]), _vm._v(" "), _c('button', {
    staticClass: "btn-block btn btn-lg btn-success",
    on: {
      "click": function($event) {
        _vm.goDashboard()
      }
    }
  }, [_vm._v("Go to dashboard")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "calModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(0), _vm._v(" "), (_vm.tempEvent.type == 1) ? _c('h4', {
    staticClass: "modal-title"
  }, [_c('i', {
    staticClass: "fa fa-paw"
  }), _vm._v(" " + _vm._s(_vm.tempEvent.title))]) : _vm._e(), _vm._v(" "), (_vm.tempEvent.type == 0) ? _c('h4', {
    staticClass: "modal-title"
  }, [_c('i', {
    staticClass: "fa fa-plane"
  }), _vm._v(" " + _vm._s(_vm.tempEvent.title))]) : _vm._e(), _vm._v(" "), (_vm.tempEvent.type == 2) ? _c('h4', {
    staticClass: "modal-title"
  }, [_c('i', {
    staticClass: "fa fa-paw"
  }), _vm._v(" " + _vm._s(_vm.tempEvent.title))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "id": "modalBody"
    }
  }, [_c('h4', [_c('strong', [_vm._v(" " + _vm._s(_vm.tempEvent.start) + " ")]), _vm._v(" to "), _c('strong', [_vm._v(" " + _vm._s(_vm.tempEvent.end) + " ")])]), _vm._v(" "), (_vm.tempEvent.type == 1) ? _c('div', [_c('h4', [_vm._v("This event cant be deleted, it's associated with "), _c('strong', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.goReservation(_vm.tempEvent.reservationId)
      }
    }
  }, [_vm._v("Booking: " + _vm._s(_vm.tempEvent.bookingNumber))])])]), _vm._v(" "), (_vm.tempEvent.blocking == true) ? _c('div', {
    staticClass: "alert h4 alert-info alert-dismissible",
    attrs: {
      "role": "alert"
    }
  }, [_vm._m(1), _vm._v("\n                    No one else can book you for these dates, to change this click here\n                    "), _c('strong', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.noBlocking(_vm.tempEvent.id)
      }
    }
  }, [_vm._v(" mark as available ")])])]) : _vm._e(), _vm._v(" "), (_vm.tempEvent.blocking == false) ? _c('div', {
    staticClass: "alert h4 alert-info alert-dismissible",
    attrs: {
      "role": "alert"
    }
  }, [_vm._m(2), _vm._v("\n                    People will still be able to book you during these dates.\n                    "), _c('strong', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.noBlocking(_vm.tempEvent.id)
      }
    }
  }, [_vm._v(" mark as un-available ")])])]) : _vm._e(), _vm._v(" "), _c('alert', [_c('strong', [_vm._v("click here")])])], 1) : _vm._e(), _vm._v(" "), (_vm.tempEvent.type == 0 || _vm.tempEvent.type == 2) ? _c('h4', [_vm._v("Click delete to remove this event from your calendar")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [(_vm.tempEvent.type == 0 || _vm.tempEvent.type == 2) ? _c('button', {
    staticClass: "btn btn-title btn-info",
    on: {
      "click": _vm.deleteEvent
    }
  }, [_vm._v("Delete")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-title btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "newEntryModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(3), _vm._v(" "), _c('h3', {
    staticClass: "modal-title",
    attrs: {
      "id": "newModalTitle"
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  }), _vm._v(" " + _vm._s(_vm.scheduleComp))])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "newModalBody"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 remove-margins"
  }, [_c('p'), _c('h4', [_vm._v("Choose Event Type")]), _c('p'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.eventTypes) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newEvent.eventType),
      expression: "newEvent.eventType"
    }],
    staticClass: "form-control input-text",
    attrs: {
      "id": "eventTypes",
      "required": "",
      "name": "eventTypes"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newEvent, "eventType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.eventTypes), function(event) {
    return _c('option', {
      domProps: {
        "value": event.type
      }
    }, [_vm._v("\n                                " + _vm._s(event.title) + "\n                            ")])
  })) : _vm._e()])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 remove-margins"
  }, [_c('div', {
    staticClass: "col-md-4 remove-margins margin-big-right"
  }, [_c('h4', {
    staticStyle: {
      "margin-bottom": "2px"
    }
  }, [_vm._v("From")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group date",
    attrs: {
      "id": "datetimepickerFrom"
    }
  }, [_c('label', {
    staticClass: "form-control ",
    attrs: {
      "type": "text",
      "readonly": "true"
    },
    model: {
      value: (_vm.newEvent.start),
      callback: function($$v) {
        _vm.$set(_vm.newEvent, "start", $$v)
      },
      expression: "newEvent.start"
    }
  }, [_vm._v(_vm._s(_vm.newEvent.start))]), _vm._v(" "), _vm._m(4)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 remove-margins margin-big-left"
  }, [_c('h4', {
    staticStyle: {
      "margin-bottom": "2px"
    }
  }, [_vm._v("To")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group date",
    attrs: {
      "id": "datetimepickerTo"
    }
  }, [_c('div', [_c('label', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": "true"
    },
    model: {
      value: (_vm.newEvent.end),
      callback: function($$v) {
        _vm.$set(_vm.newEvent, "end", $$v)
      },
      expression: "newEvent.end"
    }
  }, [_vm._v(_vm._s(_vm.newEvent.end))])]), _vm._v(" "), _vm._m(5)])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-title btn-success",
    on: {
      "click": function($event) {
        _vm.saveEvent()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-title btn-default",
    on: {
      "click": function($event) {
        _vm.cancelEvent()
      }
    }
  }, [_vm._v("Cancel")])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("close")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("close")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6876a305!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sitters/Profile/Calendar.vue
// module id = 638
// module chunks = 2